import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../utils/innerpage.css'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/withRouter';
import { clearSessionStorage } from '../../utils/constants'

const mapStateToProps = state => ({
  ...state
})

const css = `
.container-scroller {
    overflow: hidden;
  }
  
  .page-body-wrapper.full-page-wrapper {
    width: 100%;
    min-height: 100vh;
    padding-top: 0;
  }
  
  .page-body-wrapper {
    min-height: calc(100vh - 70px);
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    padding-left: 0;
    padding-right: 0;
    padding-top: 70px;
  }
  
  .content-wrapper {
    background: #dddce1;
    padding: 1.5rem 2.5rem;
    width: 100%;
    -webkit-flex-grow: 1;
    flex-grow: 1;
  }
  
  .mx-0 {
    margin-left: 0 !important;
  }
  
  .mx-auto {
    margin-left: auto !important;
  }
  
  .auth .auth-form-light {
    background: #ffffff;
    padding: 2rem 2rem !important;
  }
  
  .auth .brand-logo {
    margin-bottom: 2rem;
  }
  
  .auth .brand-logo img {
    width: 80px;
  }
  
  .click_here_to_login_btn {
    background-color: #35b3e6;
    border-color: #35b3e6;
  }
  
  .click_here_to_login_btn:hover {
    background-color: #22a3d7;
    border-color: #22a3d7;
  }
  
  .logout_content {
    text-align: center;
  }
  
  .logout_content img {
    width: 171px;
  }
  
  .logout_content h4 {
    color: #5d5d5d;
  }
  
  .logout_content h6 {
    font-weight: 300 !important;
  }
  
  .logout_content .logout_p {
    font-size: 14px;
    color: #555555;
    padding: 10px 0px;
  } 
`

class Submitted extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
    this.navigateDashoard = this.navigateDashoard.bind(this)
  }

  componentDidMount() {

  }

  navigateDashoard() {
    this.props.navigate('/applicantDashboard')
  }


  render() {
    const { } = this.state


    return (
      <>
        {/* <Header /> */}
        <div className="container-scroller" style={{ overflow: 'hidden' }}>
          <div className="container-fluid page-body-wrapper full-page-wrapper">
            {/* Left side menu */}
            {/* <Drawer /> */}

            {/* start page */}
            <div class="content-wrapper d-flex align-items-center auth px-0">
              <div class="row w-100 mx-0">
                <div class="col-lg-4 mx-auto">
                  <div class="auth-form-light text-left">
                    <div class="brand-logo">
                      <img src="img/login_logo.png" alt="logo" />
                    </div>
                    <div class="logout_content">
                      <marquee
                        style={{ fontSize: "16px", color: "#000", fontWeight: "500" }}
                        behavior="scroll"
                        direction="left"
                        scrollamount="5"
                        onMouseOver={(e) => e.target.stop()}
                        onMouseOut={(e) => e.target.start()}
                      >
                      <b>Disclaimer and Ownership: </b> All content, including text, graphics, images, and other materials on this website and associated online application systems/accounts, is the exclusive property of India ITME Society or is used under appropriate license. Unauthorized copying, reproduction, distribution, publication, display, modification, creation of derivative works, transmission, or any other form of exploitation of this content is strictly prohibited without prior written consent from the copyright owner. Any violation of these terms will result in immediate legal action and enforcement of intellectual property rights.
                      </marquee>
                      <img src="img/logout_img.png" />
                      <h4>ITME AWARDS</h4>
                      <h6 class="font-weight-light">Application Submitted Successfully.</h6>
                      <p class="logout_p">For security reasons, Please <b>exit/quit</b> your web browser</p>
                      <a class="btn btn-info click_here_to_login_btn" onClick={this.navigateDashoard}>Click here to Dashboard</a>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        <style>
          {css}
        </style>
      </>

    );
  }
}

export default withRouter(connect(null, {
})(Submitted));